import * as Styled from "./style";
import { useTrackingCollectionBannerItems } from "./use-tracking-collection-banner-items";
import type { G_GetVideoQuery } from "~/lib/graphql";
import { sendTrackingSelectOrViewPromotion } from "~/lib/tracking/events";

type BannerType = "scratch" | "onlineCrane" | "mono";
type BannerTrackingType = "scratch" | "online_crane" | "mono";
type BannerItemProps = { videoData: G_GetVideoQuery["video"]; bannerType: BannerType };

export const BannerItem = (props: BannerItemProps) => {
  const { videoData, bannerType } = props;

  const {
    relatedItems: { mono, scratch, onlineCrane },
  } = videoData;

  const onClickBanner = (name: BannerTrackingType, url: string) => {
    sendTrackingSelectOrViewPromotion({
      creativeName: "banner",
      promotionId: name,
      locationId: "footer",
      promotionName: name,
      misc: url,
    });
  };

  useTrackingCollectionBannerItems({ bannerType, scratch, onlineCrane, mono });

  return (
    <>
      {bannerType === "scratch" && scratch !== undefined && scratch !== null && (
        <Styled.AnchorBannerWrapper
          href={scratch.url}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => {
            onClickBanner("scratch", scratch.url);
          }}
        >
          <source srcSet={`${scratch.banner}?f=webp`} type="image/webp" />
          <Styled.BannerLazyImage
            src={`${scratch.banner}?f=webp` || scratch.banner}
            alt="DMMスクラッチバナー画像"
            loading="lazy"
            decoding="async"
          />
        </Styled.AnchorBannerWrapper>
      )}

      {bannerType === "onlineCrane" && onlineCrane !== undefined && onlineCrane !== null && (
        <Styled.AnchorBannerWrapper
          href={onlineCrane.url}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => {
            onClickBanner("online_crane", onlineCrane.url);
          }}
        >
          <source srcSet={`${onlineCrane.banner}?f=webp`} type="image/webp" />
          <Styled.BannerLazyImage
            src={`${onlineCrane.banner}?f=webp` || onlineCrane.banner}
            alt="DMMオンクレバナー画像"
            loading="lazy"
            decoding="async"
          />
        </Styled.AnchorBannerWrapper>
      )}

      {bannerType === "mono" && mono !== undefined && mono !== null && (
        <Styled.AnchorBannerWrapper
          href={mono.url}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => {
            onClickBanner("mono", mono.url);
          }}
        >
          <source srcSet={`${mono.banner}?f=webp`} type="image/webp" />
          <Styled.BannerLazyImage
            src={`${mono.banner}?f=webp` || mono.banner}
            alt="DMM通販バナー画像"
            loading="lazy"
            decoding="async"
          />
        </Styled.AnchorBannerWrapper>
      )}
    </>
  );
};
